import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  cnpj: null,
  empresa: null,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
